/* eslint-disable @typescript-eslint/no-explicit-any */

import { useCallback, useEffect, useState } from 'react';

export const useMatchMediaQuery = () => {
  const mobileQueryList = matchMedia(`(max-width: ${ (window as any).shared.phoneOnlyUpSize }px)`);
  const middleMobileQueryList = matchMedia(`(max-width: ${ (window as any).shared.middlePhoneOnlyUpSize }px)`);

  const [isMobile, setIsMobile] = useState(mobileQueryList.matches);
  const [isMiddleMobile, setIsMiddleMobile] = useState(middleMobileQueryList.matches);

  const handleMobileChanged = useCallback(() => {
    setIsMobile(mobileQueryList.matches);
  }, []);

  const handleMiddleMobileChanged = useCallback(() => {
    setIsMiddleMobile(middleMobileQueryList.matches);
  }, []);

  useEffect(() => {
    mobileQueryList.addEventListener('change', handleMobileChanged);
    middleMobileQueryList.addEventListener('change', handleMiddleMobileChanged);

    return () => {
      mobileQueryList.removeEventListener('change', handleMobileChanged);
      middleMobileQueryList.removeEventListener('change', handleMiddleMobileChanged);
    };
  }, []);

  return {
    isMobile,
    isMiddleMobile
  };
};
